import React, { FC } from 'react';
import ReactDOM from 'react-dom';
import Style from '../styles/components/loadingModal.module.css';

type Props = {
  show: boolean,
}

const Backdrop = () => {
  return <div className={Style.backdrop}></div>
}

const ModalOverlay = () => {

  return (
    <div className={Style.modal}>
      <div className={Style.content}>
        <div className="d-flex justify-content-center">
          <div className="spinner-border text-success" style={{ width: '9rem', height: '9rem', fontSize: '4rem' }} role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  );
}


const LoadingModal: FC<Props> = ({ show }) => {

  const portalElement = document.getElementById('overlays');

  if (!show) return null;

  return (
    <React.Fragment>
      {ReactDOM.createPortal(<Backdrop />, portalElement)}
      {ReactDOM.createPortal(<ModalOverlay />, portalElement)}
    </React.Fragment>
  )
}

export default LoadingModal;